export default {"src":"/_next/static/media/NetworkError.3d51cc89.svg","height":447,"width":740,"blurWidth":0,"blurHeight":0};